'use es6';

export const handleInitialRequests = (store, initialRequests) => {
  const {
    dispatch
  } = store;
  initialRequests.forEach(requestThunk => {
    dispatch(requestThunk());
  });
};